import api from '@/api';

const store = {
  state: {
    dataFeeSetting: {},
    isFetchingFeeSetting: false,
  },

  mutations: {
    SET_DATA_FEE_SETTING: (state, payload) => {
      state.dataFeeSetting = payload;
    },
    SET_FETCHING_FEE_SETTING: (state, payload) => {
      state.isFetchingFeeSetting = payload;
    }
  },

  getters: {
    GetDataFeeSetting: state => state.dataFeeSetting,
    GetFetchingFeeSetting: state => state.isFetchingFeeSetting
  },

  actions: {
    async GetFeeSetting({ commit }) {
      try {
        commit('SET_FETCHING_FEE_SETTING', true);
        const res = await api.GetFeeSetting();
        commit('SET_DATA_FEE_SETTING', res.data.data);
        commit('SET_FETCHING_FEE_SETTING', false);
        return res;
      } catch (e) {
        return e.response;
      }
    },

    async UpdateFeeSetting({ commit }, payload) {
      try {
        return await api.UpdateFeeSetting(payload);
      } catch (e) {
        throw e;
      }
    }
  }
};

export default store;
